<div class="timer">{{timeToDisplay}}</div>

